import React from 'react'
import Header from '../../../components/generals/header'
import stylesIndex from './../../../css/Index.module.css'
import store from '../../../reducer/store'
import styles from '../../../css/reports/Reports.module.css'
import { NavLink } from 'react-router-dom'
import { Button } from 'reactstrap'
import DataTableLazyDevices from '../../../components/generals/datatables/dataTableLazyDevices'
import { useTranslation } from 'react-i18next'

export default function DeviceActivationReport () {
  const { t } = useTranslation('deviceActivationReport')
  const { user } = store.getState()
  const role = user.roles

  const columns = [
    { field: 'status_lock', header: 'Estado de bloqueo', sistem: 'all', disabled: true },
    { field: 'type', header: 'Tipo de Equipo', sistem: 'all', disabled: true },
    { field: 'id_user', header: 'Usuario del Dispositivo', sistem: 'all', disabled: true },
    { field: 'so', header: 'Sistema Operativo', sistem: 'all', disabled: false },
    { field: 'model', header: 'Modelo', sistem: 'all', disabled: false },
    { field: 'serial_number', header: 'Número de Serie', sistem: 'all', disabled: false },
    { field: 'identity', header: 'Identificador', sistem: 'all', disabled: true },
    { field: 'last_date', header: 'Última Conexión', sistem: 'all', disabled: false },
    { field: 'first_date', header: 'Fecha de Activación', sistem: 'all', disabled: false },
    { field: 'ip_wan', header: 'Ip Wan', sistem: 'all', disabled: false }
  ]

  return (
    <div className={`content-wrapper  ${stylesIndex.flexContent}`}>
      <div className={`content  ${stylesIndex.mainContent}`}>
        <Header title={t('title')} />
        <div>
          <NavLink to="/mdm/reports">
              <Button variant="dark" className={styles.return_btn}>
                <i className="pi pi-arrow-circle-left" style={{ marginRight: '0.5rem' }}></i>
                {t('button')}
              </Button>
          </NavLink>
        </div>
        <div>
          <DataTableLazyDevices
            table="deviceActivationReport"
            onSelecteds={null}
            selectedRows={null}
            groupId={false}
            updateSelected={false}
            exportsPdf={role?.reportsPage.exportPdfInReport}
            exportsCsv={role?.reportsPage.exportCsvInReport}
            rowSelecteds={false}
            clearSelection={false}
            actionDashboard={false}
            actionDelete={false}
            columnsRole={columns}
            namePdf={t('namePdf')}
          />
        </div>
      </div>
    </div>
  )
}
